window.onload = () => {
  const domElement = document.getElementById('rdv-garage')
  if (domElement) {
    window.scrollTo(0, 310)
  }
}



// WEBPACK FOOTER //
// ./scripts/scrollRDV.js